import { render, staticRenderFns } from "./AccessesTable.vue?vue&type=template&id=8b7c4b6a&scoped=true"
import script from "./AccessesTable.vue?vue&type=script&lang=js"
export * from "./AccessesTable.vue?vue&type=script&lang=js"
import style0 from "./AccessesTable.vue?vue&type=style&index=0&id=8b7c4b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c4b6a",
  null
  
)

export default component.exports